import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const WizardStepper = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    telepules: '',
    utca: '',
    hazszam: '',
    emelet: '',
    ajto: '',
    nm2: '',
    ar: '',
    futes: '',
    leiras: ''
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    if (!token) {
      setMessage('Nincs token, jelentkezz be újra');
      navigate('/');
      return;
    }
    try {
      await axios.post('http://localhost:3001/api/properties', formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessage('Ingatlan feltöltve sikeresen!');
      // Perhaps navigate to list or dashboard
    } catch (error) {
      setMessage(error.response?.data?.error || 'Hiba történt');
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div>
            <h3>1. lépés: Cím adatok</h3>
            <input name="telepules" placeholder="Település" value={formData.telepules} onChange={handleChange} required />
            <input name="utca" placeholder="Utca" value={formData.utca} onChange={handleChange} required />
            <input name="hazszam" placeholder="Házszám" value={formData.hazszam} onChange={handleChange} />
            <input name="emelet" placeholder="Emelet" value={formData.emelet} onChange={handleChange} />
            <input name="ajto" placeholder="Ajtó" value={formData.ajto} onChange={handleChange} />
            <button onClick={nextStep}>Következő</button>
          </div>
        );
      case 2:
        return (
          <div>
            <h3>2. lépés: Ingatlan adatok</h3>
            <input name="nm2" type="number" placeholder="nm²" value={formData.nm2} onChange={handleChange} required />
            <input name="ar" type="number" placeholder="Ár (Ft)" value={formData.ar} onChange={handleChange} required />
            <input name="futes" placeholder="Fűtés" value={formData.futes} onChange={handleChange} />
            <textarea name="leiras" placeholder="Leírás" value={formData.leiras} onChange={handleChange}></textarea>
            <button onClick={prevStep}>Előző</button>
            <button onClick={nextStep}>Következő</button>
          </div>
        );
      case 3:
        return (
          <div>
            <h3>3. lépés: Ellenőrzés és feltöltés</h3>
            <p>Település: {formData.telepules}</p>
            <p>Utca: {formData.utca}</p>
            <p>nm²: {formData.nm2}</p>
            <p>Ár: {formData.ar}</p>
            <button onClick={prevStep}>Előző</button>
            <button onClick={handleSubmit}>Feltöltés</button>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <h2>Ingatlan feltöltési varázsló</h2>
      {renderStep()}
      {message && <p>{message}</p>}
    </div>
  );
};

export default WizardStepper;